export enum DashboardPageType {
  default = 'default',
  compact = 'compact',
  companies = 'companies'
}
